import { Config } from "../core/config";
function changeFavicon(faviconDirection) {
    const favicon = document.getElementById('dynamic-favicon');
    if (favicon && favicon.href !== faviconDirection) {
        favicon.href = faviconDirection;
    }
}
export function updateFavicon() {
    changeFavicon(`${window.location.origin}/${Config.favicon}`)
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/favicon.js